import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PublishCodeBookImportMutationVariables = Types.Exact<{
  importId: Types.Scalars['uuid']['input'];
}>;


export type PublishCodeBookImportMutation = { __typename?: 'mutation_root', publish_code_book_import?: { __typename?: 'PublishCodeBookImportOutput', code_book_id: any, section_count: number, links_archived: number, links_restored: number } | null };


export const PublishCodeBookImportDocument = gql`
    mutation publishCodeBookImport($importId: uuid!) {
  publish_code_book_import(input: {import_id: $importId}) {
    code_book_id
    section_count
    links_archived
    links_restored
  }
}
    `;
export type PublishCodeBookImportMutationFn = Apollo.MutationFunction<PublishCodeBookImportMutation, PublishCodeBookImportMutationVariables>;

/**
 * __usePublishCodeBookImportMutation__
 *
 * To run a mutation, you first call `usePublishCodeBookImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishCodeBookImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishCodeBookImportMutation, { data, loading, error }] = usePublishCodeBookImportMutation({
 *   variables: {
 *      importId: // value for 'importId'
 *   },
 * });
 */
export function usePublishCodeBookImportMutation(baseOptions?: Apollo.MutationHookOptions<PublishCodeBookImportMutation, PublishCodeBookImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishCodeBookImportMutation, PublishCodeBookImportMutationVariables>(PublishCodeBookImportDocument, options);
      }
export type PublishCodeBookImportMutationHookResult = ReturnType<typeof usePublishCodeBookImportMutation>;
export type PublishCodeBookImportMutationResult = Apollo.MutationResult<PublishCodeBookImportMutation>;
export type PublishCodeBookImportMutationOptions = Apollo.BaseMutationOptions<PublishCodeBookImportMutation, PublishCodeBookImportMutationVariables>;